/**
 * Каталог полов: покрытия, их типовые размеры, цвета и допустимые укладки.
 *
 * Строковый id остаётся ключом для ссылки из слоя (`CatalogRef.item`), а материал
 * задан енамом — по нему движки находят покрытие без перебора строк.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { FloorLayout, FloorMaterial, type FloorCatalogItem } from "./types";

/**
 * Укладки доступны всем покрытиям: ёлку и палубу кладут и из плитки, и из ламината,
 * а у линолеума это рисунок полотна.
 */
const ALL_LAYOUTS: readonly FloorLayout[] = [
	FloorLayout.Tile,
	FloorLayout.Straight,
	FloorLayout.Half,
	FloorLayout.Third,
	FloorLayout.FrenchHerringbone,
	FloorLayout.EnglishHerringbone,
];

export const floorSection: CatalogSection<FloorCatalogItem> = {
	kind: LayerKind.Floors,
	label: "Напольные покрытия",
	canChangeDimensions: false,
	subGroups: ["Плитка", "Ламинат", "Кварцвинил", "Линолеум"],
	items: [
		{
			id: "floor-tile",
			material: FloorMaterial.Tile,
			subGroup: "Плитка",
			name: "Плитка",
			description:
				"Керамическая плитка со швом: прямая укладка, палуба со сдвигом или ёлка. Размер плитки и шва настраиваются.",
			color: "#e9edf1",
			seamColor: "#b9c3ce",
			tile: { length: 600, width: 600, gap: 10 },
			defaultLayout: FloorLayout.Tile,
			allowedLayouts: ALL_LAYOUTS,
		},
		{
			id: "floor-laminate",
			material: FloorMaterial.Laminate,
			subGroup: "Ламинат",
			name: "Ламинат",
			description:
				"Доски ламината: палубная укладка со сдвигом, прямая, французская и английская ёлка.",
			color: "#c9a77c",
			seamColor: "#9c7b55",
			tile: { length: 1380, width: 193, gap: 2 },
			defaultLayout: FloorLayout.Straight,
			allowedLayouts: ALL_LAYOUTS,
		},
		{
			id: "floor-quartz-vinyl",
			material: FloorMaterial.QuartzVinyl,
			subGroup: "Кварцвинил",
			name: "Кварцвинил",
			description:
				"Планки кварцвинила: прямая и палубная укладка со сдвигом, французская и английская ёлка.",
			color: "#dcc09a",
			seamColor: "#b48f63",
			tile: { length: 1200, width: 200, gap: 10 },
			defaultLayout: FloorLayout.Tile,
			allowedLayouts: ALL_LAYOUTS,
		},
		{
			id: "floor-linoleum",
			material: FloorMaterial.Linoleum,
			subGroup: "Линолеум",
			name: "Линолеум",
			description:
				"Полотно линолеума без швов. Рисунок под доску или плитку - любой укладкой, своя картинка - из библиотеки.",
			color: "#cbb79a",
			seamColor: "#ad9a7e",
			tile: { length: 1200, width: 200, gap: 2 },
			defaultLayout: FloorLayout.Straight,
			allowedLayouts: ALL_LAYOUTS,
		},
	],
};
